// Vue directive to add autoresize behaviour to textareas
//
// Make sure the textarea does not have any css that will
// overwrite the manual height style, such as `height: auto !important;`
//
// Usage:
//   v-autoresize="true"

const autoresizeDirective = {
  mounted: function (el) {
    el.addEventListener('keyup', () => {
      if (el.scrollTop !== 0) {
        el.style.height = `${el.scrollHeight}px`
      }
    })

    // Trigger immediately so opening an edit form gets enlarged without the need of a keyup
    el.style.height = `${el.scrollHeight}px`
  },
}

export default autoresizeDirective
